import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Jan 30 2019
 * @author LZe
 */
import * as React from 'react';
import Button, { ButtonColor, ButtonSize } from '../../../controls/Button';
import Icon, { IconColor, IconType } from '../../../media/Icon';
import Tooltip from '../../../info/Tooltip';
import translate from '../../../i18n/translate';

var Maximize =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Maximize, _React$PureComponent);

  function Maximize() {
    var _this;

    _classCallCheck(this, Maximize);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Maximize).apply(this, arguments));

    _this.render = function () {
      return React.createElement(Tooltip, {
        overlay: React.createElement("div", null, translate('MAXIMIZE')),
        children: React.createElement("div", {
          style: {
            padding: '10px 0'
          }
        }, React.createElement(Button, {
          onClick: function onClick(event) {
            event.preventDefault();
            return _this.props.toggleMaximize();
          },
          buttonColor: ButtonColor.Light,
          buttonSize: ButtonSize.Tiny,
          iconButton: true
        }, React.createElement(Icon, {
          iconType: IconType.drag,
          iconColor: IconColor.Secondary
        }))),
        placement: "top"
      });
    };

    return _this;
  }

  return Maximize;
}(React.PureComponent);

export { Maximize as default };